module.exports = __webpack_public_path__ + "img/onGreen.67e3898f.svg";